define('modules/page_listing/views/page_stats',['require','exports','module','base/layout','./search_layout','./limitNoticeView','common/models/appstate','lib/util','ldsh!../templates/page_stats'],function (require, exports, module) {
  'use strict';
  const Layout = require('base/layout');
  const SearchView = require('./search_layout');
  const LimitNoticeView = require('./limitNoticeView');
  const AppState = require('common/models/appstate');
  const util = require('lib/util');

  const PageStatsView = Layout.extend({
    VISITS_THRESHOLD_FOR_SHOW_NOTICE: 50,
    template: require('ldsh!../templates/page_stats'),

    regions: {
      search: '.js-search',
      limitNotice: '.js-limit-notice',
    },

    triggers: {},

    events: {
      'click .js-filter-sort': 'updateSortFilter',
      'change .js-filter-show': 'updateFilters',
      'change .js-filter-hidden': 'updateFilters',
    },

    constructor: function (options) {
      this.viewModel = options.filters;
      this.pageStatsModel = options.pageStatsModel;
      module.exports.__super__.constructor.apply(this, arguments);
    },

    initialize: function (options) {
      const searchView = new SearchView({
        collection: options.userTagCollection,
        addTagsToSearch: true,
        removeTagOnDelete: true,
        filters: this.viewModel,
      });

      if (this.pageStatsModel) {
        this.listenTo(
          this.pageStatsModel,
          'sync',
          _.bind(function () {
            if (AppState._companyInfoStatus) {
              return this.addRegionAndRender();
            }
            this.listenTo(AppState._companyInfo, 'change', this.addRegionAndRender);
          }, this)
        );
      }

      options.userTagCollection.fetch({
        success: _.bind(function () {
          this.$search.show(searchView);
        }, this),
      });
    },

    addRegionAndRender: function () {
      if (this.checkForLimits()) {
        const limitNoticeView = new LimitNoticeView({
          percentage: this.getViewsPercentage(),
        });

        this.regions.limitNotice.show(limitNoticeView);
      }
      this.onRender();
    },

    updateSortFilter: function (e) {
      e.preventDefault();
      e.stopPropagation();
      const sortBy = e.currentTarget.getAttribute('data-sort');
      this.viewModel.set({
        sortBy: sortBy,
      });

      this.viewModel.setTriggerOrder(sortBy);
      this.disableField();
    },

    updateFilters: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var idElement = e.currentTarget.getAttribute('id');
      this.viewModel.set({
        filterBy: this.$('.js-filter-show').val(),
        sortBy: this.$('.js-filter-sort').val(),
        showHidden: this.$('.js-filter-hidden').is(':checked'),
      });

      if (idElement === 'show-hidden')
        this.viewModel.setTriggerHidden(this.$('.js-filter-hidden').is(':checked'));
      if (idElement === 'show-filter')
        this.viewModel.setTriggerPublished(this.$('.js-filter-show').val());

      this.disableField();
    },
    disableField: function () {
      this.viewModel.set({
        disabledFilters: true,
      });
      util.disableField('#show-hidden');
      util.disableField('#show-filter');
      util.disableField('#show-sort');
      util.disableField('.js-filter-sort ');
    },

    getViewsPercentage: function () {
      const visits = this.pageStatsModel.get('visitors') || 0;
      const maxVisits = AppState.getMaxVisits() || 1000;
      return (visits / maxVisits) * 100;
    },

    checkForLimits: function () {
      const viewsPercentage = this.getViewsPercentage();

      return viewsPercentage >= this.VISITS_THRESHOLD_FOR_SHOW_NOTICE;
    },

    helpers: function () {
      return { totalItemCount: this.viewModel.get('totalItemCount') };
    },

    onRender: function () {
      this.$el.i18n();
      if (this.viewModel.hasDisabledFilters()) {
        this.disableField();
      }
    },
  });

  module.exports = PageStatsView;
});

